export const GAME_WIDTH = 390;
export const GAME_HEIGHT = 844;

export const PLAYER_RADIUS = 18;
export const PLAYER_SPEED = 220;

export const ENEMY_MAX_ACTIVE = 28;
export const ENEMY_SPAWN_INTERVAL_MS = 780;
export const ENEMY_SPAWN_MARGIN = 42;
export const ENEMY_MIN_PLAYER_DISTANCE = 230;

export const JOYSTICK_BASE_RADIUS = 56;
export const JOYSTICK_KNOB_RADIUS = 22;
export const JOYSTICK_TOUCH_RADIUS = 96;
